export default __webpack_public_path__ + "static/media/monthly-report-icon.6021a134.svg";